import AddItemPage from '@buncha/batchDetails/screens/AddItemPage';
import B2BBarcode from '../screens/B2BBarcode';
import B2BCheckout from '../screens/B2BCheckout';
import B2BOrderInfo from '../screens/B2BOrderInfo';
import {B2BScreens} from './types';
import {ItemDetailsScreen} from '@buncha/itemDetails/navigation/types';
import ItemScanner from '@buncha/itemDetails/screens/ItemScanner';
import NSCItemScanner from '@buncha/itemDetails/screens/NSCItemScanner';
import React from 'react';
import ScannedAddItemPage from '@buncha/batchDetails/screens/ScannedAddItemPage';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {createNativeStackNavigator} from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

const B2BNavigator: React.FC = () => {
  const navigationOption = {
    gestureEnabled: false,
  };
  return (
    <Stack.Navigator
      screenOptions={{headerShown: false, gestureEnabled: false}}>
      <Stack.Screen
        name={ShopperScreens.ScannedAddItemPage}
        component={ScannedAddItemPage}
        options={navigationOption}
      />
      <Stack.Screen
        name={ShopperScreens.AddItemPage}
        component={AddItemPage}
        options={navigationOption}
      />
      <Stack.Screen
        name={B2BScreens.B2BCheckout}
        component={B2BCheckout}
        options={navigationOption}
      />
      <Stack.Screen
        name={ItemDetailsScreen.ItemScanner}
        component={ItemScanner}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={ItemDetailsScreen.NSCItemScanner}
        component={NSCItemScanner}
        options={{
          gestureEnabled: false,
        }}
      />
      <Stack.Screen
        name={B2BScreens.B2BBarcode}
        component={B2BBarcode}
        options={navigationOption}
      />
      <Stack.Screen
        name={B2BScreens.B2BOrderInfo}
        component={B2BOrderInfo}
        options={navigationOption}
      />
    </Stack.Navigator>
  );
};

export {B2BNavigator};
